module.exports = __webpack_public_path__ + "static/media/map-marker-doctor.7a59c0e8.svg";